import {
  NavigationGuard,
  NavigationGuardNext,
  Route,
  RouteConfig,
} from "vue-router";
import store, { StoreData } from "@/store";
import { tap } from "rxjs/operators";
import { combineLatest } from "rxjs";
import { Store } from "vuex";
import ParticipantIndex from "@/components/participant/index/participant-index.vue";

const MonthlyEvaluation = () =>
  import("@/components/participant/monthly-evaluation/index.vue");
const JuryTemplate = () => import("@/templates/jury/jury.template.vue");
const JuryIndex = () => import("@/components/jury/index/jury-index.vue");
const JuryProposal = () =>
  import("@/components/jury/proposal/jury-proposal.vue");
const JuryScoring = () => import("@/components/jury/scoring/scoring.vue");

const juryMiddleware: NavigationGuard = (
  to: Route,
  _from: Route,
  next: NavigationGuardNext<Vue>
) => {
  const year = (store as Store<StoreData>).state.Common.currentYear;
  if (to.name === "scoring") return next(); // by-pass
  Promise.all([
    store.dispatch("AuthStore/getUser"),
    store.dispatch("PeriodManagementStore/getPeriodManagementsByYear", {
      year,
    }),
  ]).then((res) => {
    combineLatest(res)
      .pipe(
        tap(() => {
          if (store.getters["AuthStore/isJury"]) {
            return next();
          } else {
            return next("/");
          }
        })
      )
      .subscribe();
  });
};

export default {
  path: "/jury",
  component: JuryTemplate,
  beforeEnter: juryMiddleware,
  children: [
    {
      path: "/",
      component: JuryIndex,
    },
    {
      path: "myproposals",
      name: "My Proposals",
      component: ParticipantIndex,
    },
    {
      path: "mypreviousproposal",
      component: () =>
        import("@/components/participant/my-previous-proposal/index.vue"),
    },
    {
      path: "proposal/:id/:juryDetailId",
      component: JuryProposal,
    },
    {
      path: "score/:phase/:user",
      name: "scoring",
      component: JuryScoring,
    },
    {
      path: "finalreport",
      component: () =>
        import("@/components/participant/final-report/index.vue"),
    },
    {
      path: "monev",
      component: () =>
        import("@/components/participant/final-report/index-view.vue"),
    },
    {
      path: "monev/:id/view",
      component: () =>
        import("@/components/participant/monthly-evaluation/index-view.vue"),
    },
    {
      path: "finalreport/approval",
      component: () =>
        import("@/components/participant/final-report/index-approval.vue"),
    },
    {
      path: "finalreport/:id",
      component: () =>
        import("@/components/participant/final-report/final-report.vue"),
    },
    {
      path: "monthly-evaluation/:id",
      name: "Monthly Evaluation",
      component: MonthlyEvaluation,
    },
  ],
} as RouteConfig;
